module.exports = __webpack_public_path__ + "4fcf613cf7cc8400c63feef5c3a336a4.svg";